import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, PADDING_PAGE, BACKGROUND_RESERVATION_ERROR_INFO, COLOR_RESERVATION_ERROR_ICON, FONT_SIZE_RESERVATION_ERROR_ICON } from '../../../globals';


export const StyledReservationError = styled.div`
  padding: ${PADDING_PAGE}px;

  p {
    margin: 0px;
  }

  .reservation-error-table {
    margin: 10px ${PADDING_CONTENT_PAGE}px 6px ${PADDING_CONTENT_PAGE}px;
    background-color: ${BACKGROUND_RESERVATION_ERROR_INFO};
  }

  .reservation-error-icon {
    font-size: ${FONT_SIZE_RESERVATION_ERROR_ICON}em;
    color: ${COLOR_RESERVATION_ERROR_ICON};
    padding: 10px;
  }

  .reservation-error-text {
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ReservationError/styles/StyledReservationError.js